
/*
 * mkb-framework
 * ============================================================================
 * Module App Config
 * ============================================================================
 * author: mikabo
 * http://www.mikabo.com
 * ============================================================================
 * Copyright (c) 2015, mikabo
 * All rights reserved.
 * ============================================================================
 */
define('app.config',['require','exports','module'],function(require, exports, module) {

	'use strict';

	/*TODO: ----- TODOS GENERAL -----


	*/

	var Config = {};
	Config.status = window.mkb.config.status || 'live';
	Config.url = 'http://www.holzhafen-hamburg.de/aktuelles/';

	switch (Config.status) {

	case 'local':

		Config.debug = true;
		Config.dev = true;
		Config.debugSelector = false;

		Config.domain = 'http://ww2.holzhafen-hamburg.de/';
		Config.subdomain = 'aktuelles/';
		//Config.mediathek = Config.domain + 'mkb_cms/mkb_mediathek/';
		Config.server = Config.domain + Config.subdomain;
		Config.root = Config.subdomain;
		/*Config.ajaxurl = Config.server + 'app/app.data.elbedesincrew.json';
		Config.ajaxtype = 'GET';*/

		break;

	case 'develop':

		Config.debug = false;
		Config.dev = false;
		Config.debugSelector = false;

		Config.domain = 'http://www.holzhafen-hamburg.de/';
		Config.subdomain = 'aktuelles/';
		Config.server = Config.domain + Config.subdomain;
		Config.mediathek = Config.domain + 'cms/mkb_mediathek/';
		Config.root = Config.subdomain;
		/*Config.ajaxurl = Config.server + 'includes/edc_ajax.php';
		Config.ajaxtype = 'POST';*/

		break;

	case 'live':

		Config.debug = false;
		Config.dev = false;
		Config.debugSelector = false;

		Config.domain = 'http://www.holzhafen-hamburg.de/';
		Config.subdomain = 'aktuelles/';
		Config.server = Config.domain + Config.subdomain;
		Config.mediathek = Config.domain + 'cms/mkb_mediathek/';
		Config.root = Config.subdomain;
		/*Config.ajaxurl = Config.server + 'includes/edc_ajax.php';
		Config.ajaxtype = 'POST';*/

		break;

	}

	Config.lang = undefined;

	var enablePushState = true;

	Config.router = true;
	// Disable for older browsers
	Config.pushState = !! (enablePushState && window.history && window.history.pushState);

	Config.version = '0.9.9';

	Config.cookie = 'mkb_cookie';

	Config.api = Config.server  + 'api/public/';
	Config.assets = Config.server  + 'content/themes/holzhafen/assets/';

	Config.images = Config.assets + 'src/img/';
	Config.flash = Config.assets + 'flash/';
	Config.data = Config.assets + 'data/';
	Config.lib = Config.assets + 'lib/';

	Config.mediumImageFolder = Config.mediathek + 'medium/';

	Config.blankImage ='data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';

	//-----------------------------------------------------------------------------------------------------

	Config.urlsegments = {

		menu		: 0,
		id			: 1,

		index		: '',
		currentMenu : '',
		currentId	: undefined,
		currentUrl	: ''



	};

	//-----------------------------------------------------------------------------------------------------

	Config.cache = {
		on: true,
		data:{},
		keys:[]
	};

	//-----------------------------------------------------------------------------------------------------
	Config.lang = 'de';

	Config.dict = {

		de: {
			button: {
				send    : 'abschicken',
				wait    : '...moment'

			},
			label: {},
			message: {
				successDb	: 'Der Eintrag war erfolgreich.',
				errorDb 	: 'Ein Datenbankfehler ist aufgetreten. Bitte versuchen Sie es nochmal.'
			},
			header: {
				lang: 'Sprache',
				content: '<p>Liebe Stolen Boats Freunde,</p><p>wenn ihr bei unserem Netzwerk aktiv mitmachen wollt, und helfen wollt durch eure Informationen die Chancen zu erhöhen gestohlene Boote wiederzufinden, dann registriert euch bitte durch Eingabe eurer Daten. Ihr erhaltet dann persönlich per EMail Informationen und Fahndungsblätter, wenn in Eurer Nähe ein Boot gestohlen oder gesucht wird. Führen eure Hinweise zur Aufklärung, winkt in dem einen oder anderen Fall sogar eine Belohnung.</p><h2>Schliesst euch unserem Netzwerk an und werdet Boat-Hunter!</h2>',
			},
			form: {
				headline : 'Hier bitte registrieren',
				info 		: '<b>Was ist MCS?</b><br>Mehr Informationen unter diesen Links:<br><a href="http://www.stolenboats.eu" target="_blank">stolenboats.eu</a><br><a href="http://www.mcs-germany.com" target="_blank">mcs-germany.com</a><br>',
				content 	: '<p>Zum Registrierformular:</p><p>Im Falle einer Kontaktaufnahme über das Registrierformular  ist die Angabe von Name, Vorname, Land, Stadt und E-Mail- Adresse Pflicht. Nach einem Klick auf Senden werden alle ausgefüllten Felder per Mail an MCS geschickt. Die übermittelten Daten werden strengst vertraulich behandelt und nicht an Dritte weitergegeben. Die gespeicherten Daten werden nur für den Versand von Fahndungsinformationen und zur Korrespondenz zwischen MCS und Dir genutzt. Newsletter oder Werbung werden von MCS Germany an diese Adressen nicht versendet.</p>'
			},
			bbValidation : {
				required     : ' ist ein Pflichtfeld.',
				acceptance   : ' muss akzeptiert werden.',
				min          : ' muss größer oder gleich {1} sein.',
				max          : ' muss kleiner oder gleich {1} sein.',
				range        : ' muss zwischen {1} und {2} sein.',
				length       : ' muss {1} Elemente beinhalten.',
				minLength    : ' muss mindestens {1} Elemente beinhalten.',
				maxLength    : ' darf höchstens {1} Elemente beinhalten.',
				rangeLength  : ' muss zwischen {1} und {2} Elemente beinhalten.',
				oneOf        : ' must be one of: {1}',
				equalTo      : ' muss so sein wie {1}',
				digits       : ' darf nur Digits beinhalten.',
				number       : ' muss eine Nummer sein.',
				email        : ' muss eine g&uuml;ltige Email-Adresse sein.',
				url          : ' muss eine g&uuml;ltige Url sein.',
				inlinePattern: ' ist ung&uuml;ltig.'
				}
		},
		en: {
			button: {
				send    : 'send',
				wait    : '...wait'
			},
			label: {},
			message: {

				successDb 	: 'The examination of your application has been successfully completed.',
				errorDb 	: 'Ein Datenbankfehler ist aufgetreten. Bitte versuchen Sie es nochmal.'
			},
			header: {
				lang: 'Language',
				content: '<p>Liebe Stolen Boats Freunde,</p><p>wenn ihr bei unserem Netzwerk aktiv mitmachen wollt, und helfen wollt durch eure Informationen die Chancen zu erhöhen gestohlene Boote wiederzufinden, dann registriert euch bitte durch Eingabe eurer Daten. Ihr erhaltet dann persönlich per EMail Informationen und Fahndungsblätter, wenn in Eurer Nähe ein Boot gestohlen oder gesucht wird. Führen eure Hinweise zur Aufklärung, winkt in dem einen oder anderen Fall sogar eine Belohnung.</p><h2>Schliesst euch unserem Netzwerk an und werdet Boat-Hunter!</h2>',
			},
			form: {
				headline : 'Hier bitte registrieren',
				info 		: '<b>Was ist MCS?</b><br>Mehr Informationen unter diesen Links:<br><a href="http://www.stolenboats.eu" target="_blank">stolenboats.eu</a><br><a href="http://www.mcs-germany.com" target="_blank">mcs-germany.com</a><br>',
				content 	: '<p>Zum Registrierformular:</p><p>Im Falle einer Kontaktaufnahme über das Registrierformular  ist die Angabe von Name, Vorname, Land, Stadt und E-Mail- Adresse Pflicht. Nach einem Klick auf Senden werden alle ausgefüllten Felder per Mail an MCS geschickt. Die übermittelten Daten werden strengst vertraulich behandelt und nicht an Dritte weitergegeben. Die gespeicherten Daten werden nur für den Versand von Fahndungsinformationen und zur Korrespondenz zwischen MCS und Dir genutzt. Newsletter oder Werbung werden von MCS Germany an diese Adressen nicht versendet.</p>'
			},

			bbValidation : {
				required     : ' is required',
				acceptance   : ' must be accepted',
				min          : ' must be greater than or equal to {1}',
				max          : ' must be less than or equal to {1}',
				range        : ' must be between {1} and {2}',
				length       : ' must be {1} characters',
				minLength    : ' must be at least {1} characters',
				maxLength    : ' must be at most {1} characters',
				rangeLength  : ' must be between {1} and {2} characters',
				oneOf        : ' must be one of: {1}',
				equalTo      : ' must be the same as {1}',
				digits       : ' must only contain digits',
				number       : ' must be a number',
				email        : ' must be a valid email',
				url          : ' must be a valid url',
				inlinePattern: ' is invalid'
				}
		}
	};

	//-----------------------------------------------------------------------------------------------------


	module.exports = Config;
});